var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4126 7.47944C11.4904 7.42593 11.5539 7.35432 11.5978 7.27079C11.6417 7.18726 11.6647 7.09431 11.6647 6.99995C11.6647 6.90558 11.6417 6.81263 11.5978 6.7291C11.5539 6.64557 11.4904 6.57396 11.4126 6.52045L3.82931 1.27044C3.74185 1.20968 3.6394 1.17404 3.5331 1.16741C3.4268 1.16078 3.32072 1.1834 3.22638 1.23283C3.13203 1.28226 3.05304 1.35659 2.99798 1.44776C2.94292 1.53893 2.9139 1.64344 2.91406 1.74995L2.91406 12.2499C2.9145 12.3562 2.9439 12.4603 2.99909 12.5511C3.05428 12.6419 3.13319 12.716 3.22731 12.7653C3.32143 12.8146 3.42722 12.8373 3.53329 12.831C3.63936 12.8247 3.7417 12.7896 3.82931 12.7294L11.4126 7.47944Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlack);
export default __webpack_public_path__ + "static/media/right-black.75e1cf175fc155b44ba37bc94adb9683.svg";
export { ForwardRef as ReactComponent };